export enum LoginMessages {
  UsernamePlaceholder = 'Username',
  PasswordPlaceholder = 'Password',
  ForgotPasswordLabel = 'Forgot Password?',
  SubmitButtonLabel = 'Log in',
  LoggingIn = 'Logging in...',
}

export const getTokenAndMemberIdFromHash = (hashFrag: string) => {
  const [tokenRaw, memberId] = hashFrag.split('/id=')
  const token = tokenRaw.slice(7)
  return { token, memberId }
}
